/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const CreateChangeRequestByDateRange = zod.object({
  "from": zod.coerce.date().optional(),
  "to": zod.coerce.date().optional()
});

export type CreateChangeRequestByDateRange = zod.input<typeof CreateChangeRequestByDateRange>;
export type CreateChangeRequestByDateRangeOutput = zod.output<typeof CreateChangeRequestByDateRange>;
